import React from 'react';
import IconLink from "./IconLink";
import { Box } from "@mui/material";

function PortfolioBlock(props) {
    const { image, live, source, title, buttonText, icon } = props;
    return (
        <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
            <Box 
                component={'img'} 
                src={image} 
                alt={'mockup'}
                sx={{
                    width: '640px',
                    height: '360px',
                    objectFit: 'cover'
                }}
            />
            <h1 style={{ fontSize: '2rem' }}>{title}</h1>
            <Box className={'portfolio'} display={'flex'} flexDirection={'column'} gap={'0.5rem'}
                alignItems={'center'} fontSize={'1.5rem'} py={'2rem'}>
                <Box p={1} border={'2px solid black'} borderRadius={'25px'}>
                    <IconLink link={live} title={buttonText} icon={icon || 'fa fa-youtube'} />
                </Box>
            </Box>
        </Box>
    );
}

export default PortfolioBlock;
